<div
    class="input-wrapper"
    [class.error]="hasError"
    [class.selecting]="focus"
    [class.disabledInput]="isDisabled"
    [class.dark]="dark"
    [style.cursor]="isDisabled ? 'not-allowed' : 'text'">
    <p
        class="input-label"
        data-cy="channel-input-text-field-label"
        [class.show]="!noLabel && (inputValue !== '' || focus)"
        [class.error]="hasError"
        [class.selecting]="focus"
        [class.dark]="dark"
        [class.disabledInput]="isDisabled">
        {{ label | translate }}
    </p>
    <input
        data-cy="channel-input-text-field"
        [type]="type"
        [maxlength]="maxLength"
        [name]="name"
        [(ngModel)]="inputValue"
        (ngModelChange)="onChange($event)"
        [placeholder]="[focus ? ((placeholder ? placeholder : inputValue) | translate) : (label | translate)]"
        [class.placeholder]="focus && placeholder && !value"
        (focus)="inputFocus()"
        (blur)="inputBlur()"
        (keydown)="inputKeyDown($event)"
        (wheel)="onWheel($event)"
        [readOnly]="isDisabled"
        [style.width]="passwordIconShow ? '85%' : '100%'"
        [autofocus]="false"
        [class.dark]="dark" />
    <mat-icon
        class="password-icon"
        data-cy="channel-input-text-field-eye-icon"
        *ngIf="passwordIconShow"
        [svgIcon]="type === INPUT_TYPE_PASSWORD ? 'invisible' : 'visible'"
        (click)="passwordModeChange(user, i)">
    </mat-icon>
    <div class="icon-container" *ngIf="icon">
        <mat-icon [svgIcon]="icon" class="icon" [class.selecting]="focus" data-cy="channel-input-text-field-icon" />
    </div>

    <p *ngIf="unit" class="unit">
        {{ unit | translate }}
    </p>
</div>
<div *ngIf="hasCounter" class="length-counter">
    {{ input.length + '/' + counterMax }}
</div>
<p *ngIf="hasError" class="error-message" data-cy="channel-input-text-field-error-message">
    {{ inputError?.message | translate: inputError?.params }}
</p>
